// TODO: endpoint updated to use StudlyCaps

export enum TrendDirection {
  down = 'down',
  steady = 'steady',
  up = 'up',
}
